import { useState } from 'react';
import { createModel } from 'hox';
import { TablePaginationConfig } from 'antd/es/table/interface';
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from '@/utils/constants';
import { ISaleListDetail, ISaleListSearchFields, IStatistics, saleListService } from './saleListService';
import { useGlobalModel, transPgToPaginationTotal } from '@/model/globalModel';
import { convertRes2Blob } from '@/utils/exportFile';
import { ISearchPage } from '@/types/AppTypes';
import { useDictModel } from '@/views/base/dict/dictModel';

export const useSaleListModel = createModel(function () {
	const {
		user: { shopCode },
		setLoadingInfo,
	} = useGlobalModel(({ user }) => [user]);
	const { getTreeNodeValue } = useDictModel(() => []);
	/**
	 * 列表
	 */
	//列表数据源
	const [dataSource, setDataSource] = useState<ISaleListDetail[]>([]);
	//查询条件
	const [searchParam, setSearchParam] = useState<ISaleListSearchFields>({});
	//分页参数
	const initPgCfg: TablePaginationConfig = {
		pageSize: DEFAULT_PAGE_SIZE,
		current: DEFAULT_FIRST_PAGE_NUM,
	};
	const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
	//表格多选id值
	const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
	const [statistics, setStatistics] = useState<IStatistics>({ num: 0, amount: 0 })
	const [loading, setLoading] = useState<boolean>(false);

	//列表查询
	const loadData = async (
		page: ISearchPage = initPgCfg,
		searchValue: ISaleListSearchFields = searchParam
	) => {
		setLoading(true);
		const searchParams = {
			shopCode,
			...searchValue,
			pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
			pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
		};
		let { retData } = await saleListService.page(searchParams);
		let { retData: total } = await saleListService.total(searchParams);
		total && setStatistics(total)
		const { records, ...pg } = retData;
		setPgCfg(transPgToPaginationTotal(pg));
		setDataSource(records.map(item => ({
			...item,
			currency: getTreeNodeValue(item.currencyCode),
			offerTime: item.offerTime ? item.offerTime.replace(/T/g, " ") : ""
		})));
		setLoading(false);
	};
	//设置搜索value
	const updateSearchParam = (updateParam: ISaleListSearchFields) => {
		setSearchParam({ ...searchParam, ...updateParam });
	};

	//重置搜索参数
	const resetSearchParam = () => {
		setSearchParam({});
		setSelectedRowKeys([]);
		loadData(initPgCfg, {});
	};

	//导出
	const exportSaleList = async (searchValue: ISaleListSearchFields = searchParam) => {
		setLoadingInfo({ loadingVisible: true, txt: '快速导出中' });
		try {
			const searchParams = {
				shopCode,
				...searchValue,
				pageSize: -1,
				pageNum: 1,
			};

			let result = await saleListService.export(searchParams);
			result && setLoadingInfo({ loadingVisible: false, txt: '' });
			convertRes2Blob(result);
		} catch {
			setLoadingInfo({ loadingVisible: false, txt: '' });
		}
	};


	return {
		/***field***/
		searchParam,
		dataSource,
		selectedRowKeys,
		pgCfg,
		loading, statistics,
		/***method***/
		setDataSource,
		setSelectedRowKeys,
		resetSearchParam,
		updateSearchParam,
		loadData,
		exportSaleList,
	};
});
